import { ImgProps } from "assets/images/types";

export default function ImgTodasAsFloresFooter3(props: ImgProps) {
	const { height = 277, width = 277 } = props;
	return (
		<img
			src="/assets/images/cases/todas-as-flores/todas-as-flores-footer-3.webp"
			alt="Já pensou em ter uma fragrância de novela?"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
